import { Notification } from "../../types/notifications";
import { RELEASE_NOTE_EVENT } from "../../utils/releaseNotes";

/**
 * Readable text for notification types that can be stored without a
 * `body.message` (e.g. historical message-send failures, which the backend
 * wrote with only ids). Keeps old rows from rendering a generic placeholder.
 */
const FALLBACK_MESSAGE_BY_EVENT: Record<string, string> = {
  appointment_message_send_failed: "An appointment message failed to send.",
  "appointment.messages_failed": "Appointment messages couldn't be sent.",
  form_request_skipped: "A form request couldn't be sent to a client.",
};

export const GENERIC_NOTIFICATION_MESSAGE = "You have a new notification.";

/** The text to show for a notification: its message, else its title, else a per-event fallback. */
export function getNotificationMessage(
  notification: Pick<Notification, "event_name" | "body">,
): string {
  // Release notes carry a headline (title) and a summary (message); show both,
  // one per line (the list renders with white-space: pre-line).
  if (
    notification.event_name === RELEASE_NOTE_EVENT &&
    notification.body?.title &&
    notification.body?.message
  ) {
    return `${notification.body.title}\n${notification.body.message}`;
  }
  return (
    notification.body?.message ||
    notification.body?.title ||
    FALLBACK_MESSAGE_BY_EVENT[notification.event_name] ||
    GENERIC_NOTIFICATION_MESSAGE
  );
}
